<section class="pli-document-panel" *ngIf="canRead" [attr.aria-busy]="busy" aria-label="PLI document">
  <header class="panel-header">
    <div class="panel-title">
      <h3>PLI Document</h3>
      <span class="document-status" *ngIf="loaded" [class.document-status-empty]="!documents.length">
        <mat-icon aria-hidden="true">{{documents.length ? 'check_circle' : 'info_outline'}}</mat-icon>
        {{documents.length ? 'Uploaded' : 'Not uploaded'}}
      </span>
    </div>
    <button type="button" mat-button class="refresh-button" (click)="refresh()" [disabled]="busy" aria-label="Refresh document">
      <mat-icon aria-hidden="true">refresh</mat-icon> Refresh
    </button>
  </header>
  <p class="document-message error-message" *ngIf="error" role="alert">{{error}}</p>
  <p class="document-message" *ngIf="!pliId">Save the PLI record before uploading its document.</p>
  <p class="document-message" *ngIf="busy" role="status">Loading / updating document…</p>
  <p class="empty-message" *ngIf="loaded && !documents.length">No document uploaded yet.</p>
  <p class="document-message error-message" *ngIf="documents.length > 1" role="alert">This record has multiple existing documents. They have been retained; delete the extra documents to leave one.</p>
  <div class="document-card" *ngFor="let document of documents">
    <div class="file-icon"><mat-icon aria-hidden="true">insert_drive_file</mat-icon></div>
    <div class="file-details">
      <div class="filename">{{document.filename}}</div>
      <div class="file-metadata">
        <span class="file-type">{{document.documentType}}</span>
        <span>{{document.size | fileSize}}</span>
        <span>Last modified {{document.lastModified | date:'dd MMM yyyy, HH:mm'}}</span>
        <span>Uploaded by: {{document.documentUploadedBy || 'Not recorded'}}</span>
      </div>
    </div>
    <div class="document-actions">
      <button type="button" mat-flat-button color="primary" (click)="download(document)" [disabled]="busy">
        <mat-icon aria-hidden="true">file_download</mat-icon> Download
      </button>
      <button type="button" mat-stroked-button class="delete-button" *ngIf="canWrite" (click)="deleteDocument(document)" [disabled]="busy">
        <mat-icon aria-hidden="true">delete_outline</mat-icon> Delete
      </button>
    </div>
  </div>
  <p class="document-hint" *ngIf="documents.length && canWrite">To upload a replacement, delete the existing document first.</p>
  <div class="document-upload" *ngIf="canWrite && loaded && !documents.length && !busy">
    <p class="document-hint">Select one document. Document type PLI is assigned automatically.
      <ng-container *ngIf="uploadSettings && uploadSettings.maxFileSize >= 0">Maximum file size: {{uploadSettings.maxFileSize | fileSize}}.</ng-container>
      The application's global file restrictions apply.
    </p>
    <p class="document-hint" *ngIf="uploadRestrictions?.whitelistedExtensions?.length">Allowed file types: {{uploadRestrictions.whitelistedExtensions.join(', ')}}.</p>
    <app-file-upload-selector (files)="filesChanged($event)" [fileValidator]="fileValidator"></app-file-upload-selector>
    <p class="error-message" *ngIf="files.length > 1" role="alert">Select only one document.</p>
    <button type="button" mat-flat-button color="primary" class="upload-button" (click)="upload()" [disabled]="!canUpload">
      <mat-icon aria-hidden="true">file_upload</mat-icon> Upload Document
    </button>
  </div>
</section>
